import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent {
  telefono = '5493364517062'; // 👈 reemplazá por tu número con prefijo país sin + ni 00

  get whatsappUrl(): string {
    return `https://wa.me/${this.telefono}`;
  }
}
